import { getColor } from "../../../utils/getColor";

export default {
	pageName: "ViewJob",
	animationSize: 50,

	running: {
		amplitude: 30,
		frameRate: 30,
		speed: 2,
		strokeWidth: 4,
		color: getColor("green", 5),
	},
};
